import { eventBus } from '@/main.js'
import Vue from 'vue'
export default {
  watch: {
    showBettingHistory: function (showBettingHistory) {
      if (showBettingHistory) {
        Vue.nextTick(() => {
          // let topbar = this.elementLeftMenu.getBoundingClientRect().height
          // let topBettingHistory = this.elementTopBettingHistory.getBoundingClientRect().height
          // let heighttoapplay = window.innerHeight - topBettingHistory - topbar - 50
          // this.elementBHBody = document.querySelector('.a-vg-c--body')
          // this.elementBHBody.style.height = heighttoapplay + 'px'
          if (this.isMobileDevice()) {
            this.elementSwitcher.style.position = 'fixed'
          }
          this.elementSwitcher.style.bottom = 0
        })
        this.mainPageScrollYPosition = window.pageYOffset
        window.scrollTo(0, 0)
        if (this.isMobileDevice()) {
          eventBus.onGameScrollLock('true')
        }
      } else {
        window.scrollTo(0, this.mainPageScrollYPosition)
        window.dispatchEvent(new Event('resize'))
        if (this.isMobileDevice()) {
          eventBus.onGameScrollUnock('true')
        }
        this.elementSwitcher.style.position = 'sticky'
        this.elementSwitcher.style.position = '-webkit-sticky'
        this.elementSwitcher.style.bottom = 0
      }
    }
  }
}
